export const distinctivenessColorMap = {
  'V.High': '#1a9641',
  High: '#a6d96a',
  Medium: '#ffffc0',
  Low: '#fdae61',
  'V.Low': '#d7191c',
};
